export const Header = (vendor) => `
<html>
<head>
  <style>
    .header-table {
      width: 100%;
      border-bottom: 2px solid #000;
      padding-bottom: 5px;
      page-break-inside: avoid;
      break-inside: avoid;
    }
    .header-table tr {
      page-break-inside: avoid;
      break-inside: avoid;
    }
    .header-table td {
      vertical-align: middle;
      page-break-inside: avoid;
      break-inside: avoid;
    }
    .header-table td div {
      page-break-inside: avoid;
      break-inside: avoid;
    }
    .logo {
      height: 100px;
      width: auto;
      margin-top: 15px;
      margin-left: 10px;
    }
    .address {
      text-align: right;
    }
    .center { text-align: center; }

    .vendor-line {
      font-size: 14px;
      font-weight: 500;
      margin: 5px 0;
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      page-break-inside: avoid;
      break-inside: avoid;
    }

    .vendor-item {
      display: inline-flex;
      flex-shrink: 0;
      max-width: 100%;
      page-break-inside: avoid;
      break-inside: avoid;
    }

    .vendor-item b {
      margin-right: 4px;
    }
  </style>
</head>
<body>
  <table class="header-table">
    <tr>
      <td style="width: 30%;">
        <div>
          <img
            src="https://cdn.dribbble.com/userupload/27139137/file/original-0abbbcef53d5e3f30b9b852328ac5bb2.jpg"
            class="logo"
          />
        </div>
      </td>
      <td class="address" style="width: 70%;">
        <div>
          <h3>Hypermax City Private Limited</h3>
          <p>
            Unit No 502, Block 4A, DLF Corporate Park<br />
            MG Road, Gurugram
          </p>
        </div>
      </td>
    </tr>
  </table>

  <h5 class="center">Vendor Report</h5>
  <hr/>

  <!-- Row 1 -->
  <p class="vendor-line">
    <span class="vendor-item"><b>Vendor Name:</b> ${vendor.VendorName}</span>
    <span class="vendor-item"><b>Vendor Type:</b> ${vendor.VendorType}</span>
  </p>

  <!-- Row 2 -->
  <p class="vendor-line">
    <span class="vendor-item"><b>Division:</b> ${vendor.DivisionName}</span>
    <span class="vendor-item"><b>Department:</b> ${vendor.DepartmentName}</span>
    <span class="vendor-item"><b>Email:</b> ${vendor.EmailID}</span>
  </p>

  <hr/>
</body>
</html>
`;